// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Env from "./Env.res.js";
import * as Auth from "../bundles/Auth/Auth.res.js";
import * as PosthogJs from "posthog-js";

function updateUserFields(userId, name, email) {
  if (Env.context() === "production") {
    PosthogJs.default.identify(userId, {
      name: name,
      email: email
    });
    return;
  }
}

function getSessionUrl(prim) {
  return PosthogJs.default.get_session_replay_url();
}

let Event = {};

function useCaptureEvent() {
  let auth = Auth.useState();
  return event => {
    if (typeof auth !== "object" || auth.TAG === "Logging" || auth._0.user.impersonating) {
      return;
    } else if (Env.context() === "production") {
      PosthogJs.default.capture(event);
      return;
    } else {
      return;
    }
  };
}

export {
  Event,
  updateUserFields,
  getSessionUrl,
  useCaptureEvent,
}
/* Auth Not a pure module */
